export default "__VITE_ASSET__CLbp8dmq__ 1200w";